import React, { FC, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { notificationService } from "../../../shared/services/notification-service";
import { apiEmployeeService } from "../../../shared/services/employee-service";
import { useNavigate } from "react-router-dom";
import TableHeaderOrdering, {
  Header,
} from "../../../shared/components/table-header-ordering";
import { Table } from "react-bootstrap";
import TableRowNoData from "../../../shared/components/molecules/commons/table-row-no-data";
import HolidaysFilterForm from "../components/holidays-filter-form";
import { apiHolidaysService } from "../../../shared/services/holidays-service";
import Moment from "moment-timezone";
import PaginationForm from "../../../shared/components/molecules/commons/pagination-form";
import { HolidaysFilterData } from "../../../shared/models/employee.model";
import { SystemLogService } from "../../../shared/services/system-log-service";
import { useAuth } from "../../../shared/authentications/auth-context";

type LeaveData = {
  type: string;
  used_days: number;
  total_days_allowed: number;
};

export type LeaveHistoryTypeTotal = {
  totalLeaveAmount: number;
  leaveByTypeTotal: LeaveData[];
  usedLeavePercentage: number;
};

type HolidayData = {
  id: string;
  fileName: string;
  filePath: string;
  year: string;
  createdAt: string;
  createdBy: string;
  uploaderName: string;
  status: string;
};

// Update the state types to match API response
type ApiResponse = {
  totalItems: number;
  items: HolidayData[];
  currentPage: number;
  totalPages: number;
};

const HolidaysPage: FC = () => {
  const navigate = useNavigate();
  const [employeeData, setEmployeeData] = useState([]) as any;
  const [rows, setRows] = useState<HolidayData[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const { authJwt } = useAuth();

  const createSystemLog = async (data: any) => {
    try {
      await SystemLogService.create(data);
    } catch (error) {
      const err = error as any;
      notificationService.dangerNotification("ระบบขัดข้อง", err.message);
    }
  };

  useEffect(() => {
    createSystemLog({
      employee_id: authJwt?.employee_id,
      module: "holidays",
      action: "view",
    });
  }, [authJwt?.employee_id]);

  const [queryParams, setQueryParams] = useState<any>({
    page: 1,
    page_size: 10,
});
  const headers: Header[] = [
    {
      label: "ประจำปี",
      field: "date",
      order: null,
      isOrder: true,
    },
    {
      label: "สถานะ",
      field: "status",
      order: null,
      isOrder: false,
    },
    {
      label: "สร้างเมื่อ",
      field: "created_at",
      order: null,
      isOrder: true,
    },
      {
        label: "สร้างโดย",
        field: "created_by",
        order: null,
        isOrder: true,
      },
      {
        label: "",
        field: "download",
        order: null,
        isOrder: false,
      },
  ];

  const fetchData = async () => {
    try {
      const response = await apiHolidaysService.getHolidays(queryParams);
      // Set rows to the items array from the response
      setRows(response.items || []);
      setTotalCount(response.totalItems || 0);
    } catch (error) {
      const err = error as any;
      if (err.response?.status === 400) {
        notificationService.dangerNotification(
          "ไม่พบข้อมูล",
          err.response.data.message
        );
      } else {
        notificationService.dangerNotification("ระบบขัดข้อง", err.message);
      }
      setRows([]);
      setTotalCount(0);
    }
  };

  const getEmployeeMe = async () => {
    const response = await apiEmployeeService.getEmployeeMe();
    if (response.length !== 0) {
      setEmployeeData(response);
    }
  };

  const HolidayRow: FC<{ data: HolidayData }> = ({ data }) => {
    return (
      <tr className="pointer">
        <td>{data.year || "-"}</td>
        <td>
          {data?.status
            ? data.status == "active"
              ? "กำลังใช้งาน"
              : "ไม่ได้ใช้งาน"
            : "-"}
        </td>
        <td>{data.createdAt ? Moment(data.createdAt).add(543, "year").format("DD/MM/YYYY HH:mm:ss") : "-"}</td>
        <td>{data.uploaderName || "-"}</td>
        {/* <td> <Button
          variant="primary"
          className="btn-action me-2 btn-mof-primary"
          onClick={() => {
            const url = `${process.env.REACT_APP_URI_FILE}/holidays/${data.fileName}`;
            window.open(url, '_blank', 'noopener,noreferrer');
          }}
        >
          ดาวน์โหลด
        </Button></td> */}
      </tr>
    );
  };

  const tableRowNoData = () => {
    if (rows.length === 0) {
      return <TableRowNoData colspan={6} />;
    }
    return null;
  };

  const onChangePageSize = (page_size: number) => {
    setQueryParams({
        ...queryParams,
        page_size: page_size
    });
};

const onChangePage = (page: number) => {
  setQueryParams({
      ...queryParams,
      page: page
  });
};


  useEffect(() => {
    getEmployeeMe();
    if (employeeData?.user?.id) {
      fetchData();
    }
  }, []);

  useEffect(() => {
    if (employeeData?.user?.id) {
      fetchData();
    }
  }, [employeeData?.user?.id]);

  useEffect(() => {
    console.log(queryParams);
    fetchData();
}, [queryParams]);


  return (
    <>
      <div className="d-flex justify-content-between py-4">
        <h2 className="text-mof-primary m-0">ตั้งค่าวันหยุดประจำปี</h2>
        <Button
          variant="primary"
          className="btn-action me-2 btn-mof-primary"
          onClick={() => navigate("/holidays/setting")}
        >
          + นำเข้าข้อมูล
        </Button>
      </div>
      <div className="py-2">
        <HolidaysFilterForm onFilter={(data: any) => {
          setQueryParams({
            ...queryParams,
            year: (data.year.getFullYear() + 543).toString(),
          });
        }} />
      </div>
      <div className="row mt-4">
        
        <Table striped bordered hover>
          <thead>
            <TableHeaderOrdering
              headers={headers}
              onChangeOrder={() => {}}
              isShow={true}
            />
          </thead>
          <tbody>
            {rows.map((data: HolidayData, index: number) => {
              return <HolidayRow key={data.id} data={data} />;
            })}
            {tableRowNoData()}
          </tbody>
        </Table>
        <div className="">
                <PaginationForm 
                  current_page={queryParams.page} 
                  count={totalCount}
                  page_size={queryParams.page_size}
                  onChangePageSize={onChangePageSize} 
                  onChangePage={onChangePage}
                />
            </div>
      </div>
     
    </>
  );
};

export default HolidaysPage;
